import { render } from "./FrameCard.vue?vue&type=template&id=e91da440&scoped=true"
import script from "./FrameCard.vue?vue&type=script&lang=js"
export * from "./FrameCard.vue?vue&type=script&lang=js"

import "./FrameCard.vue?vue&type=style&index=0&id=e91da440&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e91da440"]])

export default __exports__